import { DatePicker } from '@material-ui/pickers';
import React, { memo, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable } from 'react-use-observable';
import { tap } from 'rxjs/operators';
import MyModal from 'v2/components/Shared/MyModal';
import { dateFormat } from 'v2/formatters/date';
import subscriptionsService from 'v2/services/subscriptions';

interface IProps {
  isOpen: boolean;
  invoiceId: number;
  dueDate: string;
  onClose: () => void;
  retryInvoices: () => void;
  contractId: number;
}

const DueDateModal = memo(({ contractId, dueDate, onClose, isOpen, invoiceId, retryInvoices }: IProps) => {
  const [newDueDate, setNewDueDate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen && dueDate) {
      setNewDueDate(new Date(dueDate));
      return;
    }

    setNewDueDate(null);
  }, [dueDate, isOpen]);

  const handleChangeDueDate = (value: any) => {
    setNewDueDate(value);
  };

  const [handleClickOk] = useCallbackObservable(() => {
    setIsSubmitting(true);
    return subscriptionsService.setNewDueDate(contractId, invoiceId, dateFormat(newDueDate, 'yyyy-MM-dd')).pipe(
      tap(
        () => {
          toast.success('Data de vencimento da fatura alterada com sucesso!');
          setIsSubmitting(false);
          retryInvoices();
          onClose();
        },
        () => {
          setIsSubmitting(false);
          toast.error('Falha ao completar a solicitação');
        }
      )
    );
  }, [contractId, invoiceId, newDueDate]);

  if (!isOpen) {
    return null;
  }

  return (
    <MyModal
      opened={isOpen}
      title={`Nova data de vencimento para a fatura: ${invoiceId}`}
      onClose={onClose}
      onSubmit={handleClickOk}
      submitDisabled={isSubmitting}
    >
      <DatePicker
        disableToolbar
        variant='inline'
        format='dd/MM/yyyy'
        placeholder='DD/MM/YYYY'
        value={newDueDate}
        onChange={handleChangeDueDate}
        label='Data de vencimento'
        InputProps={{
          disableUnderline: true,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        minDate={new Date(dueDate)}
      />
    </MyModal>
  );
});

export default DueDateModal;
